import React, { Component } from "react";
import { observer } from "mobx-react";

import { combineEventFilters } from "@formant/core/common/combineFilters";
import { distinct } from "@formant/core/common/distinct";
import { IEventFilter } from "@formant/core/model/IEventFilter";
import { IFilter } from "@formant/core/model/IFilter";
import { Uuid } from "@formant/core/model/Uuid";

import { eventStore } from "../../stores";
import { formatUserIdDisplayName } from "../../utils/formatUserDisplayName";
import { Avatar } from "../common/Avatar";
import { IMultiSelectOption, MultiSelect } from "../common/MultiSelect";

export interface IUserSelectProps {
    value: Uuid[];
    filter: IEventFilter;
    context: IFilter;
    className?: string;
    onChange: (value: Uuid[]) => void;
}

@observer
export class UserSelect extends Component<IUserSelectProps> {
    private userIds: Uuid[] = [];
    public render() {
        const { value, filter, context, className, onChange } = this.props;
        this.userIds =
            eventStore.users(
                combineEventFilters(context, { ...filter, userIds: undefined }),
            ) || this.userIds;
        const userIds = this.userIds;
        const options = distinct([...userIds, ...value])
            .map<IMultiSelectOption<Uuid>>(id => ({
                value: id,
                extraIcon: <Avatar userId={id} size="tiny" />,
                label: formatUserIdDisplayName(id) || undefined,
            }))
            .sort((a, b) => a.label?.localeCompare(b.label || "") || 0);
        if (options.length === 0) {
            return false;
        }
        const disabled = value.length === 0 && options.length === 1;
        return (
            <MultiSelect
                value={value}
                title="User"
                options={options}
                className={className}
                onChange={onChange}
                disabled={disabled}
            />
        );
    }
}
